<template>
  <div class="product">
    <h1>{{page.name}}</h1>
 
  </div>
</template>
<script>
// @ is an alias to /src

export default {
 
  data () {
    return {
      page:{
          name : 'My Account',
          intro : 'Welcome to'

      },
      title:'Ashik',
    
    }
  },
  mounted(){
    this.$parent.$children[0].$parent.ttlval = this.page.name
    // console.log(this.$parent.$children[0].$parent.ttlval)
  }
}
</script>